import { facebookPixelService } from '@/services'
import { locale, ddlHandler, sharedFunction } from '@/util'
import { SHARED } from '@/constants/constants'
import { SHARED_LOADING, SHARED_UNLOADING } from '@/store/shared.module'

//define module name
const MODULE_NAME = 'facebookPixel/'

const A_GET_FACEBOOK_PIXELS = 'getFacebookPixels'

export const GET_FACEBOOK_PIXEL = MODULE_NAME + A_GET_FACEBOOK_PIXELS

const M_SET_FACEBOOK_PIXELS = 'setFacebookPixels'

const state = {
  facebookPixels: {
    complete: false,
    success: false,
    message: '',
    data: null
  }
}

const getters = {}

const actions = {
  [A_GET_FACEBOOK_PIXELS]({ dispatch, commit }) {
    dispatch(`${SHARED_LOADING}`, {}, { root: true })

    return facebookPixelService.getFacebookPixels().then(
      data => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_FACEBOOK_PIXELS, { result: data })
        return data
      },
      error => {
        dispatch(`${SHARED_UNLOADING}`, {}, { root: true })
        commit(M_SET_FACEBOOK_PIXELS, { result: error })
        return error
      }
    )
  }
}

const mutations = {
  [M_SET_FACEBOOK_PIXELS](state, { result }) {
    state.facebookPixels = {
      complete: true,
      success: result.status === 'success',
      message: result.message || '',
      data: result.data || null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
